import {
  CheckCircleIcon,
  EyeIcon,
  PaperPlaneTiltIcon,
  XCircleIcon,
} from "@phosphor-icons/react";

import type { RequestStatusT } from "../domain/types/requestStatus.types";
import type { VacationRequestRowUiT } from "../domain/ui/vacationRequestRow.model";

import { REQUEST_STATUS } from "../constants/status";
import { VACATION_REQUESTS_STRINGS } from "../constants/strings";

import { TableBodyAction } from "../../../../../components/v2";

type TableActionsPropsT = {
  rowData: VacationRequestRowUiT;
  isUpdating: boolean;
  onUpdateRequest: (id: string, newStatus: RequestStatusT) => void;
  onRejectRequest: (id: string) => void;
  onViewRequest: (data: VacationRequestRowUiT) => void;
};

const TableActions = ({
  rowData,
  isUpdating,
  onUpdateRequest,
  onRejectRequest,
  onViewRequest,
}: TableActionsPropsT) => {
  const newCheckStatus =
    rowData.status === REQUEST_STATUS.PENDING
      ? REQUEST_STATUS.APPROVED
      : REQUEST_STATUS.APPLIED;

  const checkIcon =
    rowData.status === REQUEST_STATUS.APPROVED ||
    rowData.status === REQUEST_STATUS.APPLIED ? (
      <PaperPlaneTiltIcon size={30} />
    ) : (
      <CheckCircleIcon size={30} />
    );

  const isActionDisabled =
    isUpdating ||
    (rowData.status !== REQUEST_STATUS.PENDING &&
      rowData.status !== REQUEST_STATUS.APPROVED);

  const handleOnView = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onViewRequest(rowData);
  };

  const handleOnUpdate = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onUpdateRequest(rowData.id, newCheckStatus);
  };

  const handleOnReject = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onRejectRequest(rowData.id);
  };

  const checkToolTip =
    rowData.status === REQUEST_STATUS.PENDING
      ? VACATION_REQUESTS_STRINGS.TEXT_TOOLTIP_APPROVE
      : VACATION_REQUESTS_STRINGS.TEXT_TOOLTIP_APPLY;

  return (
    <fieldset
      aria-label={`Acciones para solicitud de ${rowData.fullName}`}
      className="flex justify-center content-center items-center gap-2 border-none p-0 m-0"
    >
      <TableBodyAction
        icon={<EyeIcon size={30} />}
        toolTip={VACATION_REQUESTS_STRINGS.TEXT_TOOLTIP_DETAIL}
        disabled={false}
        action={handleOnView}
      />
      <TableBodyAction
        icon={checkIcon}
        toolTip={checkToolTip}
        disabled={isActionDisabled}
        action={handleOnUpdate}
      />
      <TableBodyAction
        icon={<XCircleIcon size={30} />}
        toolTip={VACATION_REQUESTS_STRINGS.TEXT_TOOLTIP_REJECT}
        disabled={isActionDisabled}
        action={handleOnReject}
      />
    </fieldset>
  );
};

export default TableActions;
